import React, { useCallback } from "react";
import PropTypes from "prop-types";

import Tooltip from "components/Tooltip";

import { useCommentFilterContext } from "../CommentFilter/useCommentFilterContext";
import CommentIconTooltipGroup from "./CommentIconTooltipGroup";

export default function CommentIcon({
  relatedEntity,
  disabled,
  newCommentRef,
  additionalStyles,
}) {
  const { openCommentDialog, applyFilter } = useCommentFilterContext();
  const hasComments = relatedEntity.numComments > 0;

  const clickHandler = useCallback(() => {
    if (disabled && !hasComments) return;
    if (!disabled) openCommentDialog();

    // scroll to the comment area, timeout is required to ensure that the new comment area has been rendered before you scroll to it
    setTimeout(() => {
      if (newCommentRef?.current?.children?.length > 0) {
        newCommentRef.current.children[0].scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 200);

    applyFilter(relatedEntity);
  }, [
    disabled,
    hasComments,
    openCommentDialog,
    applyFilter,
    relatedEntity,
    newCommentRef,
  ]);

  return (
    <Tooltip
      hidden={!disabled}
      title="Comments are currently disabled because this contact was removed from your CRM. Please merge the contact."
      position="right center"
    >
      <CommentIconTooltipGroup
        disabled={disabled}
        hasComments={hasComments}
        onClick={clickHandler}
        additionalStyles={additionalStyles}
      />
    </Tooltip>
  );
}

CommentIcon.propTypes = {
  relatedEntity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    parentId: PropTypes.string,
    name: PropTypes.string.isRequired,
    numComments: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool.isRequired,
  newCommentRef: PropTypes.object,
  additionalStyles: PropTypes.object,
};

CommentIcon.defaultProps = {
  newCommentRef: {},
  additionalStyles: {},
};
